import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HotspotService } from '../shared/hotspot.service';
import { LoaderService } from '../../shared/services/loader.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { Option } from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import { HotspotType } from '../shared/hotspot-type.model';
import { DataTableColumn } from '../../shared/data-table/data-table.component';
import { SortDirection } from '../../shared/sort-direction';
import { HotspotSearchCriteria } from '../shared/hotspot-search-criteria.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hotspot-list',
  templateUrl: './hotspot-list.component.html',
  styleUrls: ['./hotspot-list.component.scss']
})
export class HotspotListComponent implements OnInit {

  typesOptions: Option[] = [
    { labelKey: 'hotspots.list.filters.type.placeholder', value: undefined },
    { labelKey: 'hotspots.types.recycler', value: HotspotType.RECYCLER },
    { labelKey: 'hotspots.types.service-center', value: HotspotType.SERVICE_CENTER },
    { labelKey: 'hotspots.types.customer', value: HotspotType.CUSTOMER }
  ];

  filters: HotspotSearchCriteria = {};

  @ViewChild('labelColumn', { static : true })
  labelColumn: TemplateRef<any>;

  @ViewChild('positionColumn', { static : true })
  positionColumn: TemplateRef<any>;

  @ViewChild('radiusColumn', { static : true })
  radiusColumn: TemplateRef<any>;

  @ViewChild('typeColumn', { static : true })
  typeColumn: TemplateRef<any>;

  @ViewChild('addressColumn', { static : true })
  addressColumn: TemplateRef<any>;

  @ViewChild('countryColumn', { static : true })
  countryColumn: TemplateRef<any>;

  @ViewChild('actionsColumn', { static : true })
  actionsColumn: TemplateRef<any>;

  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  direction                  = SortDirection.ASC;

  loadPage = (page: number, pageSize: number, sortColumn: DataTableColumn, direction: SortDirection) =>
    this.hotspotService.search(page - 1, pageSize, sortColumn.name, direction, this.filters);

  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private hotspotService: HotspotService,
    private navigation: NavigationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const countryColumn = {
      name: 'country',
      displayed: true,
      translationKey: 'hotspots.list.table.country',
      template: this.countryColumn,
      sortable: true
    };

    this.columns = [
      {
        name: 'label',
        displayed: true,
        translationKey: 'hotspots.list.table.label',
        template: this.labelColumn,
        sortable: true
      },
      {
        name: 'position',
        displayed: true,
        translationKey: 'hotspots.list.table.position',
        template: this.positionColumn,
        sortable: false
      },
      {
        name: 'radius',
        displayed: true,
        translationKey: 'hotspots.list.table.radius',
        template: this.radiusColumn,
        sortable: false
      },
      {
        name: 'type',
        displayed: true,
        translationKey: 'hotspots.list.table.type',
        template: this.typeColumn,
        sortable: true
      },
      {
        name: 'address',
        displayed: true,
        translationKey: 'hotspots.list.table.address',
        template: this.addressColumn,
        sortable: true
      },
      countryColumn,
      {
        name: 'actions',
        displayed: true,
        translationKey: 'hotspots.list.table.actions',
        template: this.actionsColumn,
        sortable: false
      },
    ];

    this.sortColumn = countryColumn;
    this.route.queryParams.subscribe(params => {
      this.filters['label']     = params['label'];
      this.filters['type']      = params['type'];
      this.filters['latitude']  = params['latitude'];
      this.filters['longitude'] = params['longitude'];
      this.filters['radius']    = params['radius'];
    });
  }

  goToHotspot(hotspotId: string) {
    this.navigation.hotspots()
      .map(hotspotId)
      .go();
  }

  pageLoaded() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.filters
      }
    );
  }
}
